import { ShopOrderCsMemoLogItem } from '@shared/api/shopOrderCsMemo/shopOrderCsMemo.interface';
import { bareReceiverName } from '@shared/utils/receiverName.util';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

// 화환 CS 응대 로그 엑셀 — 응대 매뉴얼·교육자료용.
// 프로젝트 표준(커뮤니티 xlsx + file-saver)만 사용하고, 스타일 대신 너비·고정·필터로 읽히게 한다.

const fmt = (date: Date | string | undefined) => {
  if (!date) return '';
  const d = new Date(date);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(
    d.getHours(),
  )}:${p(d.getMinutes())}`;
};

export const exportShopCsMemoLogExcel = (
  items: ShopOrderCsMemoLogItem[],
  range: { from: string; to: string },
) => {
  const rows = items.map((item) => ({
    작성일시: fmt(item.createdAt),
    작성자: item.byName,
    역할: item.byRole === 'Admin' ? '관리자' : '판매자',
    공개범위: item.adminOnly ? '관리자 전용' : '공유',
    보내는분: item.order?.senderName ?? '',
    받는분: bareReceiverName(item.order?.receiverName) ?? '',
    상품: item.order?.itemName ?? '',
    결제상태: item.order?.paymentStatus ?? '',
    배송상태: item.order?.deliveryStatus ?? '',
    내용: item.body,
  }));

  const ws = XLSX.utils.json_to_sheet(rows);
  ws['!cols'] = [
    { wch: 18 }, // 작성일시
    { wch: 10 }, // 작성자
    { wch: 8 }, // 역할
    { wch: 12 }, // 공개범위
    { wch: 12 }, // 보내는분
    { wch: 12 }, // 받는분
    { wch: 24 }, // 상품
    { wch: 10 }, // 결제상태
    { wch: 10 }, // 배송상태
    { wch: 80 }, // 내용
  ];
  ws['!freeze'] = { xSplit: '0', ySplit: '1' };
  if (rows.length > 0) {
    ws['!autofilter'] = {
      ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: rows.length, c: 9 } }),
    };
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'CS응대로그');
  const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(
    new Blob([buf], { type: 'application/octet-stream' }),
    `화환CS응대로그_${range.from}_${range.to}.xlsx`,
  );
};
